import {NgModule} from '@angular/core'
import {DetailProgramDescMixtaComponent} from './detail-program-desc-mixta/detail-program-desc-mixta.component'
import {ModalProgramDescMixtaComponent} from './modal-program-desc-mixta/modal-program-desc-mixta.component'
import {SearchProgramsDescMixtaComponent} from './search-programs-desc-mixta/search-programs-desc-mixta.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {BrowserModule} from '@angular/platform-browser'
import {CommonModule} from '@angular/common'
import {IconsTextModule} from '../icons-text/icons-text.module'
import {DescriptionModule} from '../../description/description.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {PipesModule} from '../../../pipes/pipes.module'
import {FormsModule} from '@angular/forms'
import {InfiniteScrollModule} from 'ngx-infinite-scroll'
import {SharedModule} from '../../shared/shared.module'

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    IconsTextModule,
    DescriptionModule,
    NgbNavModule,
    PipesModule,
    FormsModule,
    InfiniteScrollModule,
    SharedModule
  ],
  declarations: [
    DetailProgramDescMixtaComponent,
    ModalProgramDescMixtaComponent,
    SearchProgramsDescMixtaComponent
  ],
  exports: [
    DetailProgramDescMixtaComponent,
    ModalProgramDescMixtaComponent,
    SearchProgramsDescMixtaComponent
  ],
  providers: []
})
export class ProgramDescMixtaModule {
}
